// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-balancer__main[data-v-6b877428]{margin-top:2rem;display:flex;flex-direction:column;justify-content:space-around;align-items:center;text-align:center}", ""]);
// Exports
module.exports = exports;
